import {
  ExportOutlined,
  PlusOutlined,
  PrinterOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Button, Input } from "antd";
import React, { useEffect, useState } from "react";

type TableActionProps = {
  setSearchText: (text: string) => void;
  onCreateNew?: () => void;
};

const TableAction: React.FC<TableActionProps> = ({
  setSearchText,
  onCreateNew,
}) => {
  const [text, setText] = useState<string | undefined>();

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchText(text || "");
    }, 500);

    return () => clearTimeout(handler);
  }, [text]);

  return (
    <div
      className="print:hidden flex"
      style={{
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        padding: 14,
        gap: 0,
      }}
    >
      <div style={{ display: "flex", width: "50%" }}>
        <Input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Input search text"
          addonBefore={<SearchOutlined />}
        />
      </div>
      <div style={{ display: "flex", gap: 12 }}>
        <Button icon={<PrinterOutlined />} onClick={() => window.print()}>
          Print
        </Button>
        <Button disabled icon={<ExportOutlined />}>
          Export
        </Button>
        {onCreateNew && (
          <Button icon={<PlusOutlined />} type="primary" onClick={onCreateNew}>
            Create new
          </Button>
        )}
      </div>
    </div>
  );
};

export default TableAction;
